import styled from "@emotion/styled";
import NoLogInHeaderMobile from "components/layout/Header/NoLogIn_Header_Mobile";
interface IPage {
  type?: string;
  children?: any;
  disable:boolean
}

const Layout = styled.div`
  width: 100%;
  min-height: 60vh;
  height: 100%;
  display: block;
  overflow: hidden;
  position: relative;
  z-index: 1;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const NoLoginPage:React.FC<IPage> = ({ children, type, disable }) => {
  return (
    <Container>
      <NoLogInHeaderMobile disable={disable} />
      <Layout className={type}>{children}</Layout>
    </Container>
  )
};

export default NoLoginPage;